import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { isEmpty, last } from 'lodash'
import { Info as InfoIcon } from 'react-feather'
import { Box, Divider, Paper, Tooltip, Typography } from '@material-ui/core'

import { DocumentTemplateItem } from './components'

import theme from 'theme'
import useStyles from './styles'

const DocumentTemplateList = ({
  documentTemplates = [],
  evidenceId,
  governanceProjectId,
  activityId,
  linkedPrivacyPolicyIds = [],
  disabledInputs = false,
  onLink = () => {},
}) => {
  const classes = useStyles()

  if (isEmpty(documentTemplates)) return null

  return (
    <Fragment>
      <Box
        display="flex"
        alignItems="center"
        gridGap={theme.spacing(1)}
        justifyContent="space-between"
      >
        <Typography variant="h6">Modelos de documento</Typography>
        <Tooltip
          title="Modelos de documento são gerados pela plataforma com os dados da organização. Se o documento ainda não existir, você pode criá-lo por aqui e ele será vinculado a esta evidência ao final do fluxo."
          arrow
        >
          <InfoIcon size={16} cursor="help" />
        </Tooltip>
      </Box>
      <Paper variant="outlined">
        <PerfectScrollbar
          options={{
            wheelPropagation: true,
            useBothWheelAxes: false,
          }}
          className={classes.templateItems}
        >
          {documentTemplates?.map((documentTemplate, index, arr) => (
            <Box key={documentTemplate?.id ?? index}>
              <DocumentTemplateItem
                documentTemplate={documentTemplate}
                evidenceId={evidenceId}
                governanceProjectId={governanceProjectId}
                activityId={activityId}
                linkedPrivacyPolicyIds={linkedPrivacyPolicyIds}
                disabledInputs={disabledInputs}
                onLink={onLink}
              />
              {documentTemplate !== last(arr) && <Divider />}
            </Box>
          ))}
        </PerfectScrollbar>
      </Paper>
    </Fragment>
  )
}

DocumentTemplateList.propTypes = {
  documentTemplates: PropTypes.arrayOf(PropTypes.object),
  evidenceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  governanceProjectId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linkedPrivacyPolicyIds: PropTypes.array,
  disabledInputs: PropTypes.bool,
  onLink: PropTypes.func,
}

export default DocumentTemplateList
